import { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import SidebarLink from './SidebarLink.view';
import { gestion, applicationMobile, marketingItems, SIDEBAR_ROUTES } from '../../constants/mainViewList';
import { onChangeClosedShop } from './Sidebar.services';
import * as actions from '../../actions/index';
import Switch from '../Switch';
import { checkSideBarAccess } from '../../utils/tools';

function SidebarContent({ oneTouch,
  closed,
  sidebarCollapse,
  sidebarShow,
  isAllShops,
  configLegal,
  dashboard,
  onClick,
  initPage, activeItem }) {
  const hideSidebar = (url) => {
    initPage();
    setActiveUrl(url)
    onClick();
  };
  const [activeUrl, setActiveUrl] = useState(window.location.pathname)
  const showBdd = (url) =>
    url !== SIDEBAR_ROUTES.CLIENTS || !dashboard?.customersTabVisibility?.hideTab;

  const allShopsSidebarItems = (
    isAllShops
      ? _.concat(gestion.listItems, applicationMobile.listItems).filter(
        item =>
          item.url === SIDEBAR_ROUTES.HOME ||
          item.url === SIDEBAR_ROUTES.FINANCES ||
          (item.url === SIDEBAR_ROUTES.INVOICE && configLegal) ||
          item.url === SIDEBAR_ROUTES.SETTINGS ||
          item.url === SIDEBAR_ROUTES.HELP ||
          item.url === SIDEBAR_ROUTES.MARKETING ||
          item.url === SIDEBAR_ROUTES.CLIENTS
      )
      : gestion.listItems
  ).filter(item => showBdd(item.url));
  const applicationMobileItems = applicationMobile.listItems;
  const marketing = marketingItems.listItems;
  return (
    <div className='sidebar__content'>
      <div className={` ${!isAllShops && 'sidebar__block'}`}>
        {_.map(allShopsSidebarItems, item => {
          return (
            <SidebarLink
              key={item.url}
              title={item.text}
              icon={item.icon}
              route={item.url}
              onClick={(url) => hideSidebar(url)}
              activeLink={activeUrl}
              newLink={item.newLink}
              disabled={checkSideBarAccess(item.url)}
              activeItem={activeItem}
            />
          );
        })}
      </div>

      {!isAllShops && (
        <div className={` ${!isAllShops && 'sidebar__block'}`}>
          {_.map(applicationMobileItems, item => {
            return (
              <SidebarLink
                key={item.url}
                title={item.text}
                icon={item.icon}
                route={item.url}
                onClick={(url) => hideSidebar(url)}
                activeLink={activeUrl}
                newLink={item.newLink}
                disabled={checkSideBarAccess(item.url)}
                activeItem={activeItem}
              />
            );
          })}
        </div>
      )}
      <div className={` ${!isAllShops && 'sidebar__block'}`}>
        {_.map(marketing, item => {
          return (
            <SidebarLink
              key={item.url}
              title={item.text}
              icon={item.icon}
              route={item.url}
              onClick={(url) => hideSidebar(url)}
              activeLink={activeUrl}
              newLink={item.newLink}
              disabled={checkSideBarAccess(item.url)}
              activeItem={activeItem}
            />
          );
        })}
      </div>

      {!isAllShops && (
        <ul className='sidebar__block'>
          {!oneTouch && (!sidebarCollapse || (sidebarShow && sidebarCollapse)) ? (
            <div style={{ display: 'flex', padding: '0px 8px' }}>
              <Switch
                color='primary'
                checked={!closed}
                onChange={() => onChangeClosedShop(closed)}
              />
              <p
                style={{
                  color: '#646777',
                  alignSelf: 'center',
                  fontSize: '14px',
                  margin: '0px'
                }}
              >
                Magasin {closed ? ' fermé' : ' ouvert'}
              </p>
            </div>
          ) : null}
        </ul>
      )}
    </div>
  );

}
function mapStateToProps({ firebaseRealTime, user }) {
  const { shop = {}, generalConfig = {} } = firebaseRealTime;
  const { closed = false } = shop;
  const { webapp = {}, terminal = {}, qrcode = {}, mobileApp = {}, url, dashboard } = generalConfig;
  const { url: oldUrl } = webapp;
  const { isAllShops, configLegal, nbShops } = user;
  return {
    oneTouch: user.oneTouchEnabled,
    isWebApp: (url || oldUrl) && (webapp.enabled || terminal.enabled || qrcode.enabled),
    isMobileApp: mobileApp.enabled,
    closed,
    isAllShops,
    configLegal,
    nbShops,
    dashboard
  };
}

export default connect(mapStateToProps, actions)(SidebarContent);
